// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__21xYZ","unreadBadge":"styles_unreadBadge__3SWgD","modalContent":"styles_modalContent__3wy94","modal":"styles_modal__2PrJ4"};